import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import { Button, ColumnProps, Table } from '@digital/ui'
import { Visibility } from '@app/components';
import { ordemCompraIdState } from '../atoms'
import { useRecoilValue } from 'recoil';
import moment from 'moment';
import { RelatorioHomologacaoAprovacao, getAprovacoes } from '@app/api/sas/relatorioHomologacao';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';
import ModalHistoricoAprovacoesArquivos from './ModalHistoricoAprovacoesArquivos';
import { isObjNotEmpty } from '@app/helpers/objHelper';

const ModalHistorioAprovacoes = () => {
    const [exibirModal, setExibirModal] = useState(false)
    const [dados, setDados] = useState([])
    const ordemCompraId = useRecoilValue(ordemCompraIdState)

    const onCancel = () => {
        setExibirModal(false)
    }

    useEffect(() => {
        if (exibirModal) {
            getAprovacoes(ordemCompraId).then(data => {
                setDados(data)
            })
        }
    }, [exibirModal])


    const columns = () => {
        const columns: ColumnProps<RelatorioHomologacaoAprovacao>[] = [];

        columns.push({
            title: 'Data',
            dataIndex: 'data',
            render(text, record) {
                return convertUTCtoLocal(moment(record.data)).toLocaleString()
            },
        })

        columns.push({
            title: 'Status',
            dataIndex: 'tipoAprovacao',
        })

        columns.push({
            title: 'Responsável',
            dataIndex: 'aprovador',
        })

        columns.push({
            title: 'Ações',
            dataIndex: 'id',
            render(text, record) {
                if (isObjNotEmpty(record.justificativa)) {
                    return <ModalHistoricoAprovacoesArquivos arquivos={record.arquivos} justificativa={record.justificativa} />
                }
                return <></>
            }
        })


        return columns;
    }

    return (
        <>
            <Button title='Histórico de aprovações' style={{ marginRight: '10px' }} onClick={() => setExibirModal(true)} type='primary' />
            <Visibility visible={exibirModal} >
                <Modal
                    title='Histórico de aprovações'
                    width='780px'
                    visible={exibirModal}
                    onCancel={onCancel}
                    footer={null}
                >
                    <Table
                        dataSource={dados}
                        columns={columns()}
                        pagination={false}
                    />
                </Modal>
            </Visibility>
        </>
    )
}

export default ModalHistorioAprovacoes